import { styled, Tabs } from '@mui/material';
import TabPanel from '../../ui/TabPanel/TabPanel';

export const AdminTabsWrapper = styled('div')({
  position: 'relative',
  marginTop: 10,
});

export const AdminTabsStyled = styled(Tabs)({
  position: 'relative',
  alignItems: 'center',
});

export const AdminTabPanel = styled(TabPanel)({
  padding: '15px 0',
});
